exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".kCKr{display:block;position:relative;float:left;width:100%}", ""]);

// exports
exports.locals = {
	"root": "kCKr",
	"root": "kCKr"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./components/ProposAccueil/ProposAccueil.css
// module id = 201
// module chunks = 0